import { compareDates } from '@/utils/dates';

export default {
    params: ['date'],
    validate: (value, { date }) => !compareDates(date, value) || 'The {_field_} field must be before {date}'
};